/* Author M. Atoar Rahman
 * Title: Facility Stock Distribution Approval
 * Description: Page for Facility Stock Distribution Approval
 * Date: 27/06/2022
 */

import { useAuth } from '../../contexts/AuthContext';
import { FacilityStockDistributionApprovalProvider } from '../facility/stockDistributionApproval/ContextAPI';
import Index from '../facility/stockDistributionApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function FacilityStockDistributionApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['facility-stock-distribution-approval']) return <PermissionDenied />;

    return (
        <FacilityStockDistributionApprovalProvider>
            <Index />
        </FacilityStockDistributionApprovalProvider>
    );
}
